export default __webpack_public_path__ + "static/media/523.b0841336.png";